import { Injectable, Signal, computed, inject } from '@angular/core';
import { IFeatureConfig } from '@partners/api';
import { FEATURE_SETTINGS } from '@partners/settings';
import { ConfigFacade } from './config.facade';

@Injectable({
  providedIn: 'root'
})
export class FeatureConfig extends ConfigFacade {
  private _featureSettings = inject(FEATURE_SETTINGS);

  get featureName(): string {
    return this._featureSettings.name;
  }

  get configDictionary$$(): Signal<IFeatureConfig> {
    return computed<IFeatureConfig>(() => {
      const featuresConfig = this._policyService.featuresConfig$$();
      /** when features config array changes read the new values to keep ui current */
      return featuresConfig?.find((f) => f.name === this.featureName);
    });
  }

  constructor() {
    super();
  }
}
